export const initialState = {
  consultants: [],
  consultant: {},
  consultantTransactions: [],
  updateConsultantStatus: "",
  request: null,
  templates: [],
  templatesLoading: false,
  templatesError: null,
  createTemplateLoading: false,
  createTemplateError: null,
  createTemplateStatus: "",
  templateStatus: "",
  deleteTemplateLoading: false,
  deleteTemplateError: null,
  deletedID: "",
  submitLoading: false,
  submitError: null,
  loading: false,
  nextToken: null,
  nextTokens: { 1: null },
  nextLoading: false,
  error: null,
  transactionsLoading: false,
  transactionsError: null,
  withdraw: {},
  withdrawStatus: {},
  withdrawLoading: null,
  withdrawError: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_CONSULTANT":
      return {
        ...state,
        consultant: {},
        error: null,
        loading: true,
      };
    case "GET_CONSULTANT_SUCCESS":
      return {
        ...state,
        consultant: action.payload.consultant,
        loading: false,
      };
    case "GET_CONSULTANT_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_UPDATE_CONSULTANT":
      return {
        ...state,
        request: action.payload.request,
        updateConsultantStatus: "",
        submitLoading: true,
        submitError: null,
      };
    case "UPDATE_CONSULTANT_SUCCESS":
      return {
        ...state,
        request: null,
        updateConsultantStatus: "SUCCESS",
        submitLoading: false,
      };
    case "UPDATE_CONSULTANT_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_LIST_CONSULTANT":
      return {
        ...state,
        consultants: [],
        nextToken: null,
        error: null,
        loading: true,
      };
    case "LIST_CONSULTANT_SUCCESS":
      return {
        ...state,
        consultants: action.payload.items,
        nextToken: action.payload.nextToken,
        loading: false,
      };
    case "LIST_CONSULTANT_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_NEXT_CONSULTANT":
      return {
        ...state,
        error: null,
        loading: true,
      };
    case "LIST_NEXT_CONSULTANT_SUCCESS":
      return {
        ...state,
        consultants: [...state.consultants, ...action.payload.items],
        nextToken: action.payload.nextToken,
        loading: false,
      };
    case "LIST_NEXT_CONSULTANT_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_CONSULTANT_TRANSACTIONS":
      return {
        ...state,
        consultantTransactions: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        transactionsError: null,
        transactionsLoading: true,
      };
    case "SUCCESS_CONSULTANT_TRANSACTIONS":
      return {
        ...state,
        consultantTransactions: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        transactionsLoading: false,
      };
    case "ERROR_CONSULTANT_TRANSACTIONS":
      return {
        ...state,
        transactionsLoading: false,
        transactionsError: action.error,
      };
    case "REQUEST_CREATE_CONSULTANT_TEMPLATE":
      return {
        ...state,
        createTemplateStatus: "",
        templateStatus: "",
        request: action.payload.request,
        createTemplateLoading: true,
        createTemplateError: null,
      };
    case "CREATE_CONSULTANT_TEMPLATE_SUCCESS":
      return {
        ...state,
        createTemplateStatus: "SUCCESS",
        templateStatus: "CREATED",
        request: null,
        createTemplateLoading: false,
        templates: [...state.templates, action.payload.template],
      };
    case "CREATE_CONSULTANT_TEMPLATE_ERROR":
      return {
        ...state,
        createTemplateStatus: "",
        templateStatus: "",
        request: null,
        createTemplateLoading: false,
        createTemplateError: action.error,
      };
    case "REQUEST_UPDATE_CONSULTANT_TEMPLATE":
      return {
        ...state,
        createTemplateStatus: "",
        templateStatus: "",
        request: action.payload.request,
        createTemplateLoading: true,
        createTemplateError: null,
      };
    case "UPDATE_CONSULTANT_TEMPLATE_SUCCESS":
      return {
        ...state,
        createTemplateStatus: "SUCCESS",
        templateStatus: "UPDATED",
        request: null,
        createTemplateLoading: false,
        templates: state.templates.map((template) => {
          if (template.id === action.payload.template.id) {
            return action.payload.template;
          }
          return template;
        }),
      };
    case "UPDATE_CONSULTANT_TEMPLATE_ERROR":
      return {
        ...state,
        createTemplateStatus: "",
        templateStatus: "",
        request: null,
        createTemplateLoading: false,
        createTemplateError: action.error,
      };
    case "REQUEST_LIST_CONSULTANT_TEMPLATES":
      return {
        ...state,
        request: action.payload.request,
        templatesLoading: true,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        templatesError: null,
      };
    case "REQUEST_MORE_CONSULTATION_TEMPLATES":
      return {
        ...state,
        nextLoading: true,
        templatesError: null,
        nextError: null,
      };
    case "LIST_CONSULTANT_TEMPLATES_SUCCESS":
      return {
        ...state,
        request: null,
        nextLoading: false,
        templatesLoading: false,
        templates: action.payload.append
          ? [...state.templates, ...action.payload.items]
          : action.payload.items,
        nextToken: action.payload.nextToken,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_CONSULTANT_TEMPLATES_ERROR":
      return {
        ...state,
        request: null,
        templatesLoading: false,
        nextLoading: false,
        templatesError: action.error,
      };
    case "RESET_ERROR_CONSULTANT_TEMPLATE":
      return {
        ...state,
        templatesError: null,
        nextError: null,
      };
    case "REQUEST_WITHDRAW_CONSULTANT_BALANCE":
      return {
        ...state,
        withdraw: {},
        withdrawStatus: "",
        withdrawError: null,
        withdrawLoading: true,
      };
    case "SUCCESS_WITHDRAW_CONSULTANT_BALANCE":
      return {
        ...state,
        withdraw: action.payload.withdraw,
        withdrawStatus: "SUCCESS",
        withdrawLoading: false,
      };
    case "ERROR_WITHDRAW_CONSULTANT_BALANCE":
      return {
        ...state,
        withdrawLoading: false,
        withdrawStatus: "",
        withdrawError: action.error,
      };
    case "CLEAR_CREATE_TEMPLATE":
      return {
        ...state,
        createTemplateStatus: "",
        createTemplateLoading: false,
        createTemplateError: null,
      };
    case "CLEAR_DELETE_TEMPLATE":
      return {
        ...state,
        deleteTemplateLoading: false,
        deleteTemplateError: null,
        deletedID: "",
      };
    case "REQUEST_DELETE_CONSULTANT_TEMPLATES":
      return {
        ...state,
        templateStatus: "",
        request: action.payload.request,
        deleteTemplateLoading: true,
        deleteTemplateError: null,
        deletedID: "",
      };
    case "DELETE_CONSULTANT_TEMPLATES_SUCCESS":
      return {
        ...state,
        templateStatus: "DELETED",
        request: null,
        deleteTemplateLoading: false,
        deletedID: action.payload.deletedID,
        templates: state.templates.filter(
          (template) => template.id !== action.payload.deletedID
        ),
      };
    case "DELETE_CONSULTANT_TEMPLATES_ERROR":
      return {
        ...state,
        templateStatus: "",
        request: null,
        deleteTemplateLoading: false,
        deleteTemplateError: action.error,
      };
    case "CLEAR_UPDATE_CONSULTANT":
      return {
        ...state,
        request: null,
        updateConsultantStatus: "",
        loading: false,
        error: null,
      };
    case "CLEAR_CONSULTANT":
      return {
        ...state,
        consultant: null,
        loading: false,
        error: null,
      };
    case "CLEAR_WITHDRAW_CONSULTANT_BALANCE":
      return {
        ...state,
        withdraw: {},
        withdrawStatus: "",
        withdrawLoading: false,
        withdrawError: null,
      };
    default:
      return state;
  }
};
